import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateGetVacancySingle = {
  getVacancySingle: { data: null, loading: false, error: null },
};

export const getVacancySingle = createAsyncThunk('user/getVacancySingle', async (id, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .get(`${process.env.REACT_APP_SERVER_API}/vacancies/${id}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerGetVacancySingle = {
  [getVacancySingle.pending]: (state) => {
    state.getVacancySingle.loading = true;
    state.getVacancySingle.error = null;
  },
  [getVacancySingle.fulfilled]: (state, action) => {
    state.getVacancySingle.loading = false;
    state.getVacancySingle.data = action.payload;
    state.getVacancySingle.error = null;
  },
  [getVacancySingle.rejected]: (state, action) => {
    state.getVacancySingle.loading = false;
    state.getVacancySingle.error = true;
  },
};
